import React from "react";
import PropTypes from "prop-types";

/**
 * Dots renders mobile-style star/dot pagination for a carousel.
 * @param {object} props - Component props.
 * @param {number} props.currentSlide - The currently active slide index.
 * @param {number} props.totalSlides - Total number of slides.
 * @param {Function} props.onDotClick - Callback invoked with the index when a dot is clicked.
 * @returns {React.ReactElement|null} Dot navigation or null if only one slide.
 */
const Dots = ({ currentSlide, totalSlides, onDotClick }) => {
  if (totalSlides <= 1) return null;

  return (
    <div className="mt-16 flex h-[15px] items-center justify-center gap-8">
      {Array.from({ length: totalSlides }).map((_, index) => {
        /**
         * Navigates the carousel to this dot's slide index.
         */
        const onThisDotClick = () => onDotClick(index);

        return (
          <button
            key={index}
            type="button"
            className="flex cursor-pointer items-center justify-center transition-all duration-300"
            style={{
              width: index === currentSlide ? "15px" : "8px",
              height: index === currentSlide ? "15px" : "8px",
            }}
            aria-label={`Go to slide ${index + 1}`}
            onClick={onThisDotClick}
          >
            {index === currentSlide ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12 12" fill="none">
                <path
                  d="M6 0L6.57554 1.68538C7.17586 3.44337 8.55663 4.82414 10.3146 5.42446L12 6L10.3146 6.57554C8.55663 7.17586 7.17586 8.55663 6.57554 10.3146L6 12L5.42446 10.3146C4.82414 8.55663 3.44337 7.17586 1.68539 6.57554L0 6L1.68538 5.42446C3.44337 4.82414 4.82414 3.44337 5.42446 1.68539L6 0Z"
                  fill="#646800"
                />
              </svg>
            ) : (
              <div className="rounded-full bg-[#8e8e8e] opacity-50" style={{ width: "8px", height: "8px" }} />
            )}
          </button>
        );
      })}
    </div>
  );
};

Dots.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  totalSlides: PropTypes.number.isRequired,
  onDotClick: PropTypes.func.isRequired,
};

export default Dots;
